import styled, { css } from 'styled-components';

import { mediaQueries } from '#@/shared/utils/styles/mediaQueries';

import { DEFAULT_TYPE } from './constants';
import type { ActionCardType } from './types';

export interface Props {
  type?: ActionCardType;
  rowCount?: 'stretch' | number;
  center?: boolean;
}

const calculateGap = (type?: ActionCardType) =>
  ({
    big: '50px',
    small: '15px',
    compact: '10px',
  })[type ?? DEFAULT_TYPE];

const ActionCardContainer = styled.div<Props>`
  display: flex;

  ${({ center }) =>
    center &&
    css`
      justify-content: center;
    `}

  @media ${mediaQueries.mobile} {
    flex-direction: column;
  }

  ${(props) => css`
    gap: ${calculateGap(props.type)};
  `}

  ${({ type, rowCount = 0 }) => {
    if (rowCount === 'stretch') {
      return css`
        & > * {
          width: 100%;
        }
      `;
    }

    if (rowCount > 1) {
      return css`
        & > * {
          width: calc(100% / ${rowCount} - ${calculateGap(type)} / ${rowCount - 1});
        }
      `;
    }

    return undefined;
  }}
`;

export default ActionCardContainer;
